"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var scenario_selectors_1 = require("../../redux/scenario/scenario.selectors");

var greeting_scenario_node_action_view_container_1 = __importDefault(require("../greeting-scenario-node-action-view/greeting-scenario-node-action-view.container"));

var greeting_scenario_node_component_1 = require("../greeting-scenario-node/greeting-scenario-node.component");

var greeting_scenario_node_template_component_1 = __importDefault(require("../greeting-scenario-node/greeting-scenario-node-template.component"));

var editable_greeting_scenario_node_styles_1 = require("./editable-greeting-scenario-node.styles");

var EditableGreetingScenarioNodeContnainer = function EditableGreetingScenarioNodeContnainer() {
  var node = react_redux_1.useSelector(scenario_selectors_1.selectGreetingScenarioNode);
  var design = react_redux_1.useSelector(scenario_selectors_1.selectDesign);
  if (!node) return null;
  return react_1.default.createElement(greeting_scenario_node_template_component_1.default, {
    node: node,
    design: design.greetingScenarioNode,
    headerButton: react_1.default.createElement(editable_greeting_scenario_node_styles_1.StyledHeaderButtonWrapperDiv, null, react_1.default.createElement(greeting_scenario_node_component_1.GreetingScenarioNodeHeaderButton, {
      backgroundColor: design.greetingScenarioNode.bodyButtonColor
    }), react_1.default.createElement(greeting_scenario_node_action_view_container_1.default, null))
  });
};

exports.default = EditableGreetingScenarioNodeContnainer;